import { useEffect, useState } from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import Navbar from "../Sections/NavBar";
import MobileNav from "../Sections/MobileNav";
import Sidebar from "./Sidebar";
import General from "./General";
import Security from "./Security";
import KYC from "./Kyc";
import UpdateTransactionPin from "./UpdateTransactionPin";
import Referrals from "./Referrals";
import GenerateAccountStatement from "./GenerateAccountStatement";
import More from "./More";

function Settings() {
  const [settingsPage, setSettingsPage] = useState("general");
  const location = useLocation();
  
  useEffect(() => {
    const renderSettingsPage = () => {
      if (location.pathname === "/settings/delete-account") {
        setSettingsPage("more")
      }
    }
    renderSettingsPage()
    
  }, [location.pathname])
  
  return (
    <>
      <Navbar dashboard />
      <MobileNav firstCrumb="Settings" />
      <Header />

      <main className="pb-8 pb-md-11 mt-md-n6">
        <div className="container-md">
          <div className="row">
            <Sidebar
              settingsPage={settingsPage}
              setSettingsPage={setSettingsPage}
            />
            {settingsPage === "security" ? (
              <Security />
            ) : settingsPage === "kyc" ? (
              <KYC />
            ) : settingsPage === "transaction" ? (
              <UpdateTransactionPin />
            ) : settingsPage === "referrals" ? (
              <Referrals />
            ) : settingsPage === "statement" ? (
              <GenerateAccountStatement />
            ) : settingsPage === "more" ? (
              <More />
            ) : (
              <General />
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default Settings;
